import viewportTypeToViewportClass from './viewportTypeToViewportClass';
export default function viewportTypeUsesCustomRenderingPipeline(viewportType) {
    return viewportTypeToViewportClass[viewportType].useCustomRenderingPipeline;
}
export function viewportUsesCustomRenderingPipeline(viewport) {
    return viewport.getUseCustomRenderingPipeline();
}
